import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=c7060b76&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=c7060b76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7060b76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7060b76')) {
      api.createRecord('c7060b76', component.options)
    } else {
      api.reload('c7060b76', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=c7060b76&scoped=true&", function () {
      api.rerender('c7060b76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2mZlPIkmmTQur/JS/comp/PopupBox.vue"
export default component.exports